export function createEdgeRoutingWorker() {
  return new Worker(new URL('./edgeRouting.worker.js', import.meta.url));
}
